<template>
  <div class="animated fadeIn">
    <b-modal
      ref="resetModal"
      hide-footer
      title="개인정보 업데이트 리셋"
      size="lg"
    >
      <b-row>
        <b-col md="12">
          <h4>리셋 할까요?</h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <b-button
            variant="outline-danger"
            block
            @click="resetUpdated()"
          >
            리셋
          </b-button>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col md="12">
          <b-button
            variant="outline-success"
            block
            @click="$refs.resetModal.hide()"
          >
            취소
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      ref="remnantModal"
      lazy
      ok-only
      title="렘넌트 정보"
      size="lg"
    >
      <b-row>
        <remnant-basic
          ref="remnantBasic"
          :email="email"
          :read-only="true"
        />
      </b-row>
      <b-row>
        <b-col md="12">
          <b-input-group
            prepend="새암호"
            class="mt-3"
          >
            <b-form-input v-model="passwd" />
            <b-input-group-append>
              <b-button
                variant="danger"
                @click="resetPasswd()"
              >
                Reset!
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
    </b-modal>
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>렘넌트 전체 개인정보 리셋</strong>
          </div>
          <b-row>
            <b-col md="12">
              <b-button
                variant="outline-danger"
                :disabled="noAuth"
                block
                @click="$refs.resetModal.show()"
              >
                리셋
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>암호 리셋</strong>
          </div>
          <b-row>
            <b-col md="12">
              <b-input-group
                prepend="Email"
                class="mt-3"
              >
                <b-form-input v-model="email" />
                <b-input-group-append>
                  <b-button
                    variant="outline-success"
                    :disabled="noAuth"
                    @click="searchRemnant()"
                  >
                    검색
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>{{ currentTerm }} 문서 잠금 설정</strong>
          </div>
          <b-row>
            <b-col
              md="2"
              class="text-left"
            >
              <b-form-checkbox
                v-model="lock.apply"
                switch
                @change="setLockApply"
              >
                장학신청서
                <font-awesome-icon
                  v-if="lock.apply"
                  :icon="['fas', 'lock']"
                />
                <font-awesome-icon
                  v-else
                  :icon="['fas', 'lock-open']"
                />
              </b-form-checkbox>
            </b-col>
            <b-col
              md="2"
              class="text-left"
            >
              <b-form-checkbox
                v-model="lock.summit"
                switch
                @change="setLockSummit"
              >
                성적표제출
                <font-awesome-icon
                  v-if="lock.summit"
                  :icon="['fas', 'lock']"
                />
                <font-awesome-icon
                  v-else
                  :icon="['fas', 'lock-open']"
                />
              </b-form-checkbox>
            </b-col>
            <b-col
              md="3"
              class="text-left"
            >
              <b-form-checkbox
                v-model="lock.longterm"
                switch
                @change="setLockLongterm"
              >
                장기장학생 보고서
                <font-awesome-icon
                  v-if="lock.longterm"
                  :icon="['fas', 'lock']"
                />
                <font-awesome-icon
                  v-else
                  :icon="['fas', 'lock-open']"
                />
              </b-form-checkbox>
            </b-col>
            <b-col
              md="2"
              class="text-left"
            >
              <b-form-checkbox
                v-model="lock.review"
                switch
                @change="setLockReview"
              >
                부서심의
                <font-awesome-icon
                  v-if="lock.review"
                  :icon="['fas', 'lock']"
                />
                <font-awesome-icon
                  v-else
                  :icon="['fas', 'lock-open']"
                />
              </b-form-checkbox>
            </b-col>
            <b-col
              md="2"
              class="text-left"
            >
              <b-form-checkbox
                v-model="lock.donate"
                switch
                @change="setLockDonate"
              >
                기탁서
                <font-awesome-icon
                  v-if="lock.donate"
                  :icon="['fas', 'lock']"
                />
                <font-awesome-icon
                  v-else
                  :icon="['fas', 'lock-open']"
                />
              </b-form-checkbox>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>

import RemnantBasic from '../remnant/RemnantBasic'
import api from '../../api'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faLockOpen, faLock } from '@fortawesome/free-solid-svg-icons'
library.add(faLock, faLockOpen)

export default {
  name: 'AdminControl',
  components: { RemnantBasic },
  data: function () {
    return {
      email: '',
      passwd: '',
      noAuth: true,
      lock: {
        apply: null,
        summit: null,
        longterm: null,
        donate: null,
        review: null
      }
    }
  },
  computed: {
    currentTerm () {
      return api.currentTerm()
    }
  },
  mounted () {
    if (this.$store.getters.isRealSuper) {
      this.noAuth = false
      this.getLock()
      return
    }
    this.$router.push('/dashboard')
  },
  methods: {
    setLockApply (val) {
      this.setLock('apply', val)
    },
    setLockSummit (val) {
      this.setLock('summit', val)
    },
    setLockLongterm (val) {
      this.setLock('longterm', val)
    },
    setLockReview (val) {
      this.setLock('review', val)
    },
    setLockDonate (val) {
      this.setLock('donate', val)
    },
    setLock (docType, val) {
      // post arg 세팅
      var postArg = {}
      postArg['doc'] = docType
      postArg['term'] = api.currentTerm()
      postArg['lock'] = val ? '1' : '0'

      api.request('post', '/admin/control/lock', postArg)
        .then(response => {
        })
        .catch(error => {
          alert('잠금실패', error)
        })
    },
    getLock () {
      Object.keys(this.lock).forEach(key => {
        api.request('get', '/admin/control/lock?doc=' + key + '&term=' + api.currentTerm())
          .then(response => {
            let data = response.data
            this.lock[key] = data.lock
          })
          .catch(error => {
            console.log(error)
            alert('락정보 가져오기 실패')
          })
      })
    },
    searchRemnant () {
      this.$refs.remnantModal.show()
      this.passwd = ''
    },
    resetPasswd () {
      // post arg 세팅
      var postArg = {}
      postArg['email'] = this.email
      postArg['passwd'] = this.passwd

      api.request('post', '/admin/reset/passwd', postArg)
        .then(response => {
          alert('reset 완료')
        })
        .catch(error => {
          alert('reset 실패!', error)
        })
    },
    resetUpdated () {
      api.request('get', '/admin/reset/updated')
        .then(response => {
          alert('reset 완료')
          this.$refs.resetModal.hide()
        })
        .catch(error => {
          alert('reset 실패!', error)
        })
    }
  }
}
</script>

<style scoped>
.photobox {
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  max-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}
  /* IE fix */
#card-chart-01, #card-chart-02 {
  width: 100% !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
